import { render, staticRenderFns } from "./CashRegisterForm.vue?vue&type=template&id=3bee66c2"
import script from "./CashRegisterForm.vue?vue&type=script&lang=js"
export * from "./CashRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports